export const MAX_RECORDING_SECONDS = 60;
export const MAX_RECORDING_BYTES = 2 * 1024 * 1024;
export const RECORDING_MIME_TYPES = ['audio/webm', 'audio/mp4', 'audio/ogg', 'audio/wav', 'audio/m4a', 'audio/mpeg'];
export const recordingMimeType = value => String(value || '').split(';')[0].trim().toLowerCase();
